import { useState, useEffect } from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';
import { renderInputRow } from '../../../utils/renderInputRow';

const SectionCard = ({ icon, title, desc, children }) => (
    <div className="cpiw-card">
        <div className="cpiw-card__header">
            <div className="cpiw-card__header-icon"><span style={{ fontSize: '16px' }}>{icon}</span></div>
            <div>
                <div className="cpiw-card__title">{title}</div>
                {desc && <div className="cpiw-card__desc">{desc}</div>}
            </div>
        </div>
        <div className="cpiw-card__body">{children}</div>
    </div>
);

const OtherSettingsTab = ({ toast }) => {
    const [originalOtherSettings, setOriginalOtherSettings] = useState({});
    const [otherSettings, setOtherSettings]                 = useState({});
    const [loading, setLoading]                             = useState(false);

    useEffect(() => {
        const global = window.CPIW_GLOBAL_OPTIONS || {};
        setOtherSettings(global);
        setOriginalOtherSettings(global);
    }, []);

    const handleSave = () => {
        const changedData = Object.fromEntries(
            Object.entries(otherSettings).filter(([k, v]) => originalOtherSettings[k] !== v)
        );
        if (Object.keys(changedData).length === 0) {
            toast.warning('No changes detected.');
            return;
        }
        setLoading(true);
        apiFetch({ path: `/wp/v2/settings`, method: 'POST', data: changedData })
            .then(() => {
                setLoading(false);
                toast.success('Text settings saved successfully!');
                setOriginalOtherSettings(otherSettings);
                window.CPIW_GLOBAL_OPTIONS = { ...otherSettings };
            })
            .catch((err) => {
                console.error(err);
                setLoading(false);
                toast.error('Error saving text settings.');
            });
    };

    const updateSetting = (key, value) => setOtherSettings(prev => ({ ...prev, [key]: value }));

    return (
        <div className="plugin-general-tab">
            {loading && (
                <div className="cpiw-overlay-loader">
                    <div className="cpiw-spinner-wrap">
                        <div className="cpiw-spinner" />
                        <span className="cpiw-spinner-label">Saving changes…</span>
                    </div>
                </div>
            )}

            <SectionCard icon="📝" title="Check Pincode Text Settings" desc="Customize all customer-facing text labels for the pincode widget.">
                {renderInputRow('Input Placeholder Text',             'cpiw_pincodeplace_text',    '', [], '', otherSettings, updateSetting)}
                {renderInputRow('Check Availability Text',            'cpiw_checkavail_text',      '', [], '', otherSettings, updateSetting)}
                {renderInputRow('Not Serviceable Text',               'cpiw_checkunavail_text',    '', [], '', otherSettings, updateSetting)}
                {renderInputRow('Delivery Available Text',            'cpiw_delivery_to_text',     '', [], '', otherSettings, updateSetting)}
                {renderInputRow('Delivery Date Label',                'cpiw_delivery_date_text',   '', [], '', otherSettings, updateSetting)}
                {renderInputRow('COD Available Text',                 'cpiw_codavail_text',        '', [], '', otherSettings, updateSetting)}
                {renderInputRow('COD Unavailable Text',               'cpiw_codunavail_text',      '', [], '', otherSettings, updateSetting)}
            </SectionCard>

            <SectionCard icon="🔔" title="Popup Text Settings" desc="Customize text shown inside the pincode popup dialog.">
                {renderInputRow('Popup Info Text',          'cpiw_checklocationtext_text', '', [], '', otherSettings, updateSetting)}
                {renderInputRow('Submit Button Text',       'cpiw_cpopsubmit_text',        '', [], '', otherSettings, updateSetting)}
                {renderInputRow('Popup Input Placeholder', 'cpiw_cpopplaceholder_text',   '', [], '', otherSettings, updateSetting)}
                {renderInputRow('Popup Available Text',    'cpiw_popavailabletext',       '', [], '', otherSettings, updateSetting)}
                {renderInputRow('Empty Field Error Text',  'cpiw_emptyfield_text',        '', [], '', otherSettings, updateSetting)}
            </SectionCard>

            <div className="cpiw-save-bar">
                <p className="cpiw-save-bar__hint">
                    <strong>&#9888; Unsaved changes</strong> — Click Save to apply your settings.
                </p>
                <div className="cpiw-save-bar__actions">
                    <button className="cpiw-btn" onClick={handleSave}>&#10003; Save Changes</button>
                </div>
            </div>
        </div>
    );
};

export default OtherSettingsTab;
